<template>
  <v-skeleton-loader v-if="file.loading" type="list-item"></v-skeleton-loader>
  <div v-else class="d-flex justify-space-between">
    <div class="d-flex align-center ga-2">
      <div class="icon--blue" style="height: 30px; width: 30px">
        <v-icon icon="mdi-file-document-outline" size="small"></v-icon>
      </div>
      <div class="d-flex flex-column">
        <span class="font-size-13">{{ file.name }}</span>
        <div class="text-disabled font-size-11 d-flex align-center ga-1">
          <span>{{ formatFileSize(file.size) }}</span>
          <span>·</span>
          <span>{{
            new CustomDate(file.createdAt).toString({
              time: true,
            })
          }}</span>
          <span v-if="file.user">·</span>
          <span v-if="file.user">{{
            getPersonName(file.user, { initials: true })
          }}</span>
        </div>
      </div>
    </div>
    <div class="d-flex align-center ga-2">
      <v-btn
        border
        color="white"
        density="comfortable"
        @click.stop="openDocument(file.path)">
        <div class="font-size-12">
          <v-icon class="mr-1">mdi-eye</v-icon>
          <span class="font-weight-medium">Переглянути</span>
        </div>
      </v-btn>
      <b-action-menu :actions="actions" @click.stop>
        <template #activator="{ props }">
          <v-btn
            density="comfortable"
            icon="mdi-dots-horizontal"
            size="small"
            v-bind="props"></v-btn>
        </template>
      </b-action-menu>
    </div>
  </div>
</template>

<script>
import { formatFileSize, openDocument } from '@/utils/helpers.js'
import { download } from 'best-modules/vue-utils'
import { BActionMenu } from 'best-modules/components'
import { CustomDate } from 'best-modules/utils'
import { ref } from 'vue'
import { getPersonName } from 'best-modules/utils/helpers'

export default {
  emits: ['remove-file'],
  components: { BActionMenu },
  props: {
    file: { type: Object },
    disabled: { type: Boolean },
  },
  methods: { getPersonName, CustomDate },
  setup(props, { emit }) {
    const menu = ref(false)

    const actions = [
      {
        title: 'Завантажити',
        action: () => download(props.file.path, props.file.name),
        icon: 'mdi-file-download-outline',
        disabled: props.file.loading,
        iconProps: {
          color: 'blue-darken-3',
        },
      },
      {
        title: 'Видалити',
        action: () => emit('remove-file', props.file),
        icon: 'mdi-delete-forever',
        disabled: props.disabled || props.file.loading,
        iconProps: {
          color: 'error',
        },
      },
    ]

    return {
      download,
      openDocument,
      actions,
      menu,
      formatFileSize,
    }
  },
}
</script>

<style lang="scss" scoped></style>
